import React from 'react';
import {
	Card,
	CardContent,
	CardMedia,
	Typography,
	Box,
	Rating,
} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

const ProductCard = () => {
	return (
		<Box
			display={'flex'}
			justifyContent={'space-between'}
			alignItems={'center'}>
			<Box
				style={{
					background: '#f5f5f5',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					// height: '120px',
					padding: 10,
				}}>
				<img
					src='https://m.media-amazon.com/images/I/61UGJ7z-sUL._AC_UY327_FMwebp_QL65_.jpg'
					style={{
						width: '100%',
						height: '100px',
						objectFit: 'contain',
						mixBlendMode: 'multiply', // Removes white background
					}}
				/>
			</Box>

			<Box ml={2}>
				<span style={{ fontSize: 14 }}>
					{' '}
					Snpurdiri 60% Wired Gaming Keyboard
				</span>
				<br />
				<span>$500</span>
				<br />
				<span>Delivery</span>
				<Box
					style={{
						background: '#ffd814',
						textAlign: 'center',
						padding: 7,
						borderRadius: '40px',
					}}>
					<span style={{ fontSize: 13, fontWeight: 500 }}>Add to Cart</span>
				</Box>
			</Box>
		</Box>
	);
};

export default ProductCard;
